// import React from "react";

// export default function Tab({ name, type, data, updateDataSource, updateSelectedTab, selectedTab, dataArrayName }) {
//     function click() {
//         updateDataSource(dataArrayName)
//         updateSelectedTab(name)
//     }
//     return (
//         <div className={selectedTab === name ? 'TabOn' : 'Tab'} onClick={click}>
//             <span className="type1">{data}</span> <span className="type"> {type}</span>
//             <div> {name}</div>
//         </div>
//     );
// }
import React from "react";
const color = {
    "WEEKLY MEASUREMENT": "#F2994A",
    PUSHUP: "#7D56A5",
    "NEAR POINT": "#35BFEA"
}
export default function Tab({
    tabName,
    last,
    tabUnit,
    tabMS,
    dataArrayName,
}) {
    let noData = dataArrayName.length < 1;

    // console.log("tabName", tabName, "last", last);
    return (
        <div className={"TabOn"} >

            {/* <div className="line"> */}
            <div className="tabName" >{tabName}</div>
            {noData ?
                <div>no data yet</div>
                : <>
                    <div style={{ color: color[tabName] }}>
                        {last}
                        <span style={{ fontSize: "12px", paddingLeft: "0.2rem" }}>{tabUnit}</span>
                    </div>
                    <div className="tabMS" > {tabMS}</div>
                </>}
        </div>
    );
}
